import React from 'react'
import { Button } from 'antd'

import history from '../../history'

const AppError = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: 24,
    textAlign: 'center',
  }}
  >
    <h2>A aplicação falhou</h2>
    <p>Ocorreu um erro inesperado.</p>
    <Button type="primary" onClick={() => history.push('/loads')}>
      Voltar para cargas
    </Button>
  </div>
)

export default AppError
